import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ManageService } from '../../../services/manage.service';
import { Observable, Subject } from 'rxjs';
import { catchError, debounceTime, finalize, map, mergeMap, retry, switchMap, takeUntil, tap } from 'rxjs/operators';
import { CSPTenantUser, ICSP_CustomerPricing } from '../../../models/csp.model';
import { fromEvent, of } from 'rxjs';
import { AuthService } from '../../../services/auth.service';
import { CurrentUserModel } from '../../../models/account-ledger.model';
import { CommonService } from '../../../services';
import { ApiResponse } from '../../../models/api-response.model';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FileService } from '../../../services/file.service';
import { HttpClient } from '@angular/common/http';

declare var $: any;

@Component({
    selector: 'app-configure-portal-management',
    templateUrl: './configure-portal-management.component.html',
    styleUrls: ['./configure-portal-management.component.css']
})
export class ConfigurePortalManagement implements OnInit, OnDestroy, AfterViewInit {
  public title = 'Configurue End User Portal';
  public access = false;
  public hidePricing = false;
  public notificationEmail: string;
  public color: string;
  public uploadFile: File;
  public files: File[] = [];
  public fileName: string;
  public file: any;
  preivewLoading = false;
  disableRequest = false;
  public showTransferButton = false;
  previewResult: ICSP_CustomerPricing[]
  originalTenantUsers: CSPTenantUser[];
  tenantUsers: CSPTenantUser[];
  addedtenantUsers: CSPTenantUser[] = [];
  loadContent: boolean;
  endUserSearchStr: string;
  accountId: string;
  tenantId: string;
  isLoading = false;
  ngUnsubscribe: Subject<void> = new Subject<void>();
  email_regex = new RegExp('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$');

  searchInput$ = new Subject<string>();
  endUserList: any[] = [];

  public previewColumns: string[] = [
    'tenantId',
    'stockCode',
    'price'
  ];

  public form: FormGroup = this.fb.group({
    preferences: this.fb.group({
      managementOption: ['view_only'],
      CancelSubscriptionAllowed:[false],
      pricingOption: ['rrp_only'],
      notificationEmail: ['', Validators.email]
    }),
    contactDetails: this.fb.group({
      contactEmail: ['', Validators.email],
      contactPhone: ['', Validators.pattern('^[0-9]+$')],
      companyName: [''],
      address1: [''],
      address2: [''],
      suburb: [''],
      state: [''],
      postcode: ['', [Validators.pattern('^[0-9]{4}$')]]
    })
  });

  constructor(
      private manageService: ManageService,
      private authService: AuthService,
      private commonService: CommonService,
      private router: Router,
      private fb: FormBuilder,
      private http: HttpClient,
      private activatedRoute: ActivatedRoute,
      private fileService: FileService
  ) {
  }

  async ngAfterViewInit() {
    await this.commonService.waitForElm('#levelOne');
    $('#levelOne').animate({ scrollLeft: $('#managecsp').width() + 505 }, 400);
  }

  ngOnInit() {
    this.loadContent = false;

    this.authService.getLoginInfo().pipe(takeUntil(this.ngUnsubscribe)).subscribe((currentUserModel: CurrentUserModel) => {
        this.accountId = currentUserModel.accountId;
    });

    this.activatedRoute.parent.paramMap
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (param) => {
          this.tenantId = param.get('tenantId');

          this.manageService.getTenantBranding_V1(this.tenantId)
            .pipe(switchMap((res: any) => {
              if (res.imageUrl) {
                return this.downloadImage(res.imageUrl).pipe(
                  map((file: File) => {
                    return {
                      color: res.colorCode,
                      managementOption: res.managementOption,
                      CancelSubscriptionAllowed:res.cancelSubscriptionAllowed,
                      pricingOption: res.pricingOption,
                      notificationEmail: res.notificationEmail,
                      email: res.email,
      
                      contactEmail: res.contactEmail,
                      contactPhone: res.contactPhone,
                      address1: res.address1,
                      address2: res.address2,
                      companyName: res.companyName,
                      suburb: res.suburb,
                      postcode: res.postCode,
                      state: res.state,
      
                      file: file
                    };
                  })
                );
              } else {
                return of({
                  color: res.colorCode,
                  managementOption: res.managementOption,
                  CancelSubscriptionAllowed:res.cancelSubscriptionAllowed,
                  pricingOption: res.pricingOption,
                  notificationEmail: res.notificationEmail,
                  email: res.email,
      
                  contactEmail: res.contactEmail,
                  contactPhone: res.contactPhone,
                  address1: res.address1,
                  address2: res.address2,
                  companyName: res.companyName,
                  suburb: res.suburb,
                  postcode: res.postCode,
                  state: res.state,
      
                  //address3: res.address3,
                  file: null
                });
              }
            }))
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((payload) => {
              //"#00abc2"
              this.color = payload.color ? payload.color : '#00abc2';
              this.notificationEmail = payload.email;

              this.form.get('preferences.managementOption').setValue(payload.managementOption);
              this.form.get('preferences.CancelSubscriptionAllowed').setValue(payload.CancelSubscriptionAllowed);
              this.form.get('preferences.pricingOption').setValue(payload.pricingOption);
              this.form.get('preferences.notificationEmail').setValue(payload.notificationEmail);

              this.form.get('contactDetails.contactEmail').setValue(payload.contactEmail);
              this.form.get('contactDetails.contactPhone').setValue(payload.contactPhone);
              this.form.get('contactDetails.companyName').setValue(payload.companyName);
              this.form.get('contactDetails.address1').setValue(payload.address1);
              this.form.get('contactDetails.address2').setValue(payload.address2);
              this.form.get('contactDetails.suburb').setValue(payload.suburb);
              this.form.get('contactDetails.state').setValue(payload.state);
              this.form.get('contactDetails.postcode').setValue(payload.postcode);
        
              if (payload.file) {
        
                this.uploadFile = payload.file;
                this.files.push(this.uploadFile);
        
              }
        
              this.loadContent = true;
            }, () => {
              this.loadContent = true;
            });
        }
      });
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  downloadSampleFile(): void {
    this.loadContent = false;
    this.fileService.saveFile('Sample_Custom_Pricing_File.xlsx').subscribe(res => {
      this.fileService.saveAsExcelFile(res, 'Sample_Custom_Pricing_File.xlsx');
      this.loadContent = true;
    },
      (error: any) => {
          console.error(error);
          this.loadContent = true;
      });
  }

  onBlur() {
    this.searchInput$.next('');
  }

  updateTenantBranding() {
    if(this.form.invalid)
    {
      this.commonService.implementToast('Contact Us Form has invalid fields', 'Error');
      return;
    }

    const inputData = {
      tenantId: this.tenantId,
      colorCode: this.color,
      managementOption: this.form.get('preferences.managementOption')?.value,
      CancelSubscriptionAllowed:this.form.get('preferences.managementOption')?.value === 'create' ? this.form.get('preferences.CancelSubscriptionAllowed')?.value : false,
      pricingOption: this.form.get('preferences.pricingOption')?.value,
      notificationEmail: this.form.get('preferences.notificationEmail')?.value,

      companyName: this.form.get('contactDetails.companyName')?.value,
      contactEmail: this.form.get('contactDetails.contactEmail')?.value,
      contactPhone: this.form.get('contactDetails.contactPhone')?.value,
      address1: this.form.get('contactDetails.address1')?.value,
      address2: this.form.get('contactDetails.address2')?.value,
      state: this.form.get('contactDetails.state')?.value,
      suburb: this.form.get('contactDetails.suburb')?.value,
      postcode: this.form.get('contactDetails.postcode')?.value
    };

    const companyLogoFile = this.uploadFile ?  this.uploadFile : null;
    const customPricingFile = this.file ? this.file : null;

    const formData = new FormData();
    formData.append('tenantBranding', JSON.stringify(inputData));
    if (companyLogoFile)  formData.append('companyLogoFile', this.uploadFile);
    if (customPricingFile)  formData.append('customPricingFile', this.file);

    this.loadContent = false;
    this.manageService.updateTenantBranding_V1(formData).subscribe((res: ApiResponse) => {

      if (res.status) {
        this.loadContent = true;
        this.commonService.implementToast('Site Branding Updated Successfully', 'Success');
      } else {
        this.loadContent = true;
        this.commonService.implementToast('Failed to Update Tenant Branding', 'Error');
      }
    });
  
  }

  onSelectFile(event): void {
    this.preivewLoading = false;
    this.disableRequest = false;
    this.previewResult = [];
    this.showTransferButton = false;
    this.file = "";
    this.fileName = "";
      this.loadContent = false;
      this.file = event.target.files[0];
      this.fileName = this.file?.name;
      //this.previewBulkResult = [];
      this.loadContent = true;
  }

  allowDrop(ev) {
    ev.preventDefault();
  }
  
  drop(ev) {
    this.loadContent = false;

    // Prevent default behavior (Prevent file from being opened)
    ev.preventDefault();

    if (ev.dataTransfer.items) {
      // Use DataTransferItemList interface to access the file(s)
      [...ev.dataTransfer.items].forEach((item, i) => {
        // If dropped items aren't files, reject them
        if (item.kind === "file") {
          const file = item.getAsFile();
          this.file = file
          this.fileName = this.file.name;
          //this.resultTableDataSrc = [];
        }
      });
    }
    this.loadContent = true;
  }
    
  downloadImage(url: string): Observable<File | null> {

      const fileName = url.substring(url.lastIndexOf('/') + 1);

      const fileExtension = url.substring(url.lastIndexOf('.') + 1);

      const fileType = `image/${fileExtension}`;

      return this.http.get(`${url}?v=${(+new Date).toString(36)}`, {
          responseType: 'blob'
      }).pipe(
          map((data: Blob) => {
          const image = new File([data], fileName, {
              type: fileType,
          });
          return image;
          }),
          retry(3),
          catchError(() => {
              this.commonService.implementToast('failed to download company logo', 'Error');
              return of(null);
          })
      );
  }

  onSelect(event) {

      //over file size limit
      if (event.rejectedFiles.length > 0) {
        this.commonService.implementToast('max file size is 1MB', 'Error');
  
      } else {
  
        this.files = [];
  
        const reader = new FileReader();
  
        reader.onload = () => {
  
          const img = document.createElement('img') as HTMLImageElement;
  
          img.onload = () => {
  
            const canvas = this.resizeImage(img, img.naturalWidth, img.naturalHeight);
  
            canvas.toBlob(
              (blob) => {
                //const fileExtension = event.addedFiles[0].name
                this.uploadFile = new File([blob], `${this.tenantId}.png`, {
                  type: 'image/png',
                });
                this.files.push(this.uploadFile);
              },
              'image/png',
              1);
  
          };
  
          img.src = reader.result as string;
        };
  
        reader.readAsDataURL(event.addedFiles[0]);
      }
  }

  onRemove(event) {
      this.uploadFile = null;
      this.files.splice(this.files.indexOf(event), 1);
  }

  deleteImage() {

      this.manageService.deleteTenantLogo(this.tenantId).subscribe((res: ApiResponse) => {
          if (res.status) {
  
            this.files = [];
  
            this.uploadFile = null;
  
            this.commonService.implementToast('Tenant Logo has been deleted Successfully', 'Success');
  
          } else {
            this.commonService.implementToast('Failed to Delete Tenant Logo', 'Error');
          }
        },
        () => {
          this.commonService.implementToast('Failed to Delete Tenant Logo', 'Error');
        });
      ;
  
  }

  resizeImage(img: any, width: number, height: number) {

      const maxWidth = 400;
  
      const maxHeight = 100;
  
      let ratio;
  
      const canvas = document.createElement('canvas') as HTMLCanvasElement;
  
      var ctx = canvas.getContext('2d');
  
      if (width > maxWidth) {
  
        ratio = maxWidth / width;
  
        width = width * ratio;
  
        height = height * ratio;
  
      }
  
      // Check if current height is larger than max
      if (height > maxHeight) {
  
        ratio = maxHeight / height;
  
        width = width * ratio;
  
        height = height * ratio;
  
      }
  
      canvas.width = width;
  
      canvas.height = height;
  
      ctx.drawImage(img, 0, 0, width, height);
  
      return canvas;
  
  }    

  preview() {
    this.loadContent = false;
    const formData = new FormData();
    formData.append(this.file.name, this.file);
    this.manageService
      .previewCustomPricing(formData)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (res: any[] | ApiResponse) => {
          if ('responseMessage' in res && !(res as ApiResponse)?.status) {
            this.commonService.implementToast(res.responseMessage, 'Error');
          } else {
            this.showTransferButton = true;
            this.previewResult = [...(res as any[])]
          }
        },
        (error: any) => {
          this.commonService.implementToast(error, 'Error');
        },
        () => {
          this.preivewLoading = false
        }
      );
  }

  public downloadCurrentCustomPricing(): void {
    this.preivewLoading = true;
    this.disableRequest = true;

    this.manageService
      .DownloadCustomPricing(this.tenantId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (res: any) => {
          const fileName = `${this.tenantId}_Custom_PriceFile`;
          this.fileService.saveAsExcelFile(res, fileName);
          this.commonService.implementToast('downloaded successfully', 'Success');
          // this.resetPage();
        },
        (error: any) => {
          console.error(error);
        },
        () => {
          this.preivewLoading = false;
          this.disableRequest = false;
        }
      );
  }

  public showCustomPricingPreviewTable(): boolean {
    return this.previewResult?.length && this.form.get('preferences.pricingOption')?.value == 'custom_pricing';
  }

  public onAllowCancel(event) {
    console.log('Toggle switched:', event.checked);
    const cancelSubscriptionAllowedValue = event.checked;
    this.form.get('preferences.CancelSubscriptionAllowed')?.setValue(cancelSubscriptionAllowedValue);
  }

  public close() {
    this.manageService.sendCurrentSoftwareSubscription(null);
    this.router.navigate(['../'], { queryParamsHandling: 'preserve', relativeTo: this.activatedRoute })
    $('#levelOne').animate({ scrollLeft: 250 }, 400);
  }

  ngOnDestroy() {
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
  }
}
